import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navigationmenu: props.viewEcommerce
        ? [
            {
              id: 1,
              linkText: "Home",
              child: false,
              link: "/",
            },
            {
              id: 5,
              linkText: "Categories",
              child: true,
              submenu: [
                {
                  id: 41,
                  link: "/shop",
                  linkText: "Shop",
                },
              ],
            },
            {
              id: 2,
              linkText: "About Us",
              child: false,
              link: "/about",
            },
            {
              id: 3,
              linkText: "Verify Certificate",
              child: false,
              link: "/verify",
            },
            {
              id: 4,
              linkText: "Contact Us",
              child: false,
              link: "/contact",
            },
            {
              id: 5,
              linkText: "Cart",
              child: false,
              link: "/cart",
            },
          ]
        : [
            {
              id: 1,
              linkText: "Home",
              child: false,
              link: "/verify",
            },

            {
              id: 2,
              linkText: "About Us",
              child: false,
              link: "/about",
            },
            {
              id: 3,
              linkText: "Verify Certificate",
              child: false,
              link: "/verify",
            },
            {
              id: 4,
              linkText: "Contact Us",
              child: false,
              link: "/contact",
            },
          ],
    };
  }
  getNextSibling = function (elem, selector) {
    // Get the next sibling element
    var sibling = elem.nextElementSibling;
    // If there's no selector, return the first sibling
    if (!selector) return sibling;
    // If the sibling matches our selector, use it
    // If not, jump to the next sibling and continue the loop
    while (sibling) {
      if (sibling.matches(selector)) return sibling;
      sibling = sibling.nextElementSibling;
    }
  };
  triggerChild = (e) => {
    let subMenu = "";
    subMenu =
      this.getNextSibling(e.target, ".sub-menu") !== undefined
        ? this.getNextSibling(e.target, ".sub-menu")
        : null;
    if (subMenu !== null && subMenu !== undefined && subMenu !== "") {
      subMenu.classList = subMenu.classList.contains("d-block")
        ? "sub-menu"
        : "sub-menu d-block";
    }
  };

  componentDidMount = () => {
    axios.get("https://gemsgnine.com/admin/get-all-category").then((res) => {
      // navigationmenu[1]["submenu"]
      if (this.props.viewEcommerce) {
        let newArr = [];
        let arr = this.state.navigationmenu;
        res.data.forEach((item) => {
          let subArr = [];
          if (item.subcategories) {
            item.subcategories.forEach((subitem) => {
              subArr.push({
                id: parseInt(subitem.sub_id) + 10,
                link: "/shop?category=" + subitem.sub_id + "&name=" + item.name,
                linkText: subitem.name,
              });
            });
          }
          newArr.push({
            id: parseInt(item.id) + 10,
            link: "/shop?category=" + item.id + "&name=" + item.name,
            linkText: item.name,
            child: item.subcategories ? true : false,
            submenu: item.subcategories ? subArr : null,
          });
        });
        arr[1]["submenu"] = newArr;
        this.setState({ navigationmenu: arr });
      }
    });
  };

  render() {
    return (
      <ul className="navbar-nav">
        {this.state.navigationmenu.length > 0
          ? this.state.navigationmenu.map((item, i) => (
              <li
                key={i}
                className={`menu-item ${
                  item.child ? "menu-item-has-children" : ""
                } `}
                onClick={this.triggerChild}
                style={{
                  color:
                    this.props.location.pathname === "/product"
                      ? "black"
                      : "white",
                }}
              >
                {item.child ? (
                  <Link onClick={(e) => e.preventDefault()} to="/">
                    {" "}
                    {item.linkText}{" "}
                  </Link>
                ) : (
                  <Link to={item.link}> {item.linkText} </Link>
                )}
                {item.child ? (
                  <ul className="sub-menu" role="menu">
                    {item.submenu.map((sub_item, i) => (
                      <li
                        key={i}
                        className={`menu-item ${
                          sub_item.child ? "menu-item-has-children" : ""
                        } `}
                      >
                        {sub_item.child ? (
                          <Link onClick={(e) => e.preventDefault()} to="/">
                            {" "}
                            {sub_item.linkText}{" "}
                          </Link>
                        ) : (
                          <Link to={sub_item.link}> {sub_item.linkText} </Link>
                        )}
                        {sub_item.submenu ? (
                          <ul className="sub-menu">
                            {sub_item.submenu.map((third_item, i) => (
                              <li className="menu-item" key={i}>
                                <Link to={third_item.link}>
                                  {third_item.linkText}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        ) : null}
                      </li>
                    ))}
                  </ul>
                ) : null}
              </li>
            ))
          : null}
      </ul>
    );
  }
}

export default Menu;
